import { render, staticRenderFns } from "./containerDespachante.vue?vue&type=template&id=591e2d82&scoped=true&"
import script from "./containerDespachante.vue?vue&type=script&lang=js&"
export * from "./containerDespachante.vue?vue&type=script&lang=js&"
import style0 from "./containerDespachante.vue?vue&type=style&index=0&id=591e2d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591e2d82",
  null
  
)

export default component.exports